export const MICROSITE_MODEL = "microsite";

const micrositeModel = {
  name: "",
  slug: "",
  micrositeId: "",
  isLive: 0,
  pages: {
    jsonApi: "hasMany",
    type: "microsite-pages"
  }
};

export default micrositeModel;
